export class emailSubscribe {
    emailid:String ="";   
}